import React, { Component } from 'react';
import { chunks } from './App';

class ProductRows extends React.Component {
    render() {
        const name = this.props.product.name;
        const link = name + ".html";
        return (
            <li><a href={link}>{name}</a></li>
        );
    }
}

class ProductTable extends React.Component {
    render() {
        const rows = chunks(this.props.products, 8);
        var count = 0;
        var html = rows.map((row) => (
            <div className="col-6 col-md-3" key={count++}>
                <ul className="list-unstyled footer-links">
                    {/*{
                    row.map((product) => (
                        <ProductRows product={product} key={product.name} />
                    ))
                }*/}
                </ul>
            </div>
        ));
        return (
            <div className="row">{html}</div>
        )
    }
}

export default class Footer extends React.Component {
    render() {

        // Set language styling for chinese
        if(this.props.language == "chi"){
            var useTextSlabClass = "";
        } else {
            var useTextSlabClass = " text-slab";
        }

        
        const translationTextPreseli = { en: "Preseli ", chi: "百事利" }
        const translationTextEngSupply = { en: "Engineering Supplies Ltd", chi: "器材有限公司" }
        const translationTextAddressLine1 = { en: "Flat 11, 8/F, Profit Industrial Building,", chi: "葵芳葵豐街一至十五號" }
        const translationTextAddressLine2 = { en: "1-15, Kwai Fung Crescent, Kwai Fong, N.T., Hong Kong", chi: "盈業工廠大厦8樓11室" }
        const translationTextCopyright = { en: "Copyright", chi: "版權所有" }

        return (
            <footer id="footer">
                <div className="container">
                    <div className="row">

                        <div className="col-lg-4">
                            <h3 className={"text-white text-uppercase font-weight-bold" + useTextSlabClass}>
                                {this.props.getTranslatedText("Preseli")}<span className="text-primary">{this.props.getTranslatedText("EngSupply")}</span>
                            </h3>
                            <p className="text-sm"></p>
                            <address>
                                <ul className="list-unstyled text-sm">
                                    <li>
                                        <abbr title="Phone">
                                            <i className="fa fa-phone fa-fw text-white"></i></abbr>
                                        (+852) 24236378
                                    </li>
                                    <li>
                                        <abbr title="Fax"><i className="fa fa-fax fa-fw text-white"></i></abbr>
                                        (+852) 24872790
                                    </li>
                                    <li>
                                        <abbr title="Email"><i className="fa fa-envelope fa-fw text-white"></i></abbr>
                                        sales@preseli.com.hk
                                    </li>
                                    <li>
                                        <abbr title="Address"><i className="fa fa-home fa-fw text-white"></i></abbr>
                                        {this.props.getTranslatedText("AddressLine1")}
                                        {this.props.getTranslatedText("AddressLine2")}
                                    </li>
                                </ul>
                            </address>
                            {/*<!--social media icons-->*/}
                            <div className="mt-3 mb-4 mb-lg-0">
                                {/*<!--@todo: replace with company social media details-->*/}
                                {/* <a href="#" className="btn btn-icon btn-inverse btn-invert btn-rounded"> <i className="fa fa-twitter"></i> <span className="sr-only">Twitter</span> </a>
                                <a href="#" className="btn btn-icon btn-inverse btn-invert btn-rounded"> <i className="fa fa-facebook"></i> <span className="sr-only">Facebook</span> </a>
                                <a href="#" className="btn btn-icon btn-inverse btn-invert btn-rounded"> <i className="fa fa-linkedin"></i> <span className="sr-only">Linkedin</span> </a>
                                <a href="#" className="btn btn-icon btn-inverse btn-invert btn-rounded"> <i className="fa fa-google-plus"></i> <span className="sr-only">Google plus</span> </a> */}
                            </div>
                        </div>

                        <div className="col-lg-7 offset-lg-1">
                            <ProductTable products={this.props.products} />
                        </div>
                    </div>

                    <hr className="my-4 hr-white op-1" />
                    <div className="subfooter text-sm text-center">
                        <p>{translationTextCopyright[this.props.language]} 2018 &copy; {translationTextPreseli[this.props.language]}{translationTextEngSupply[this.props.language]}</p>
                        <ul className="list-inline footer-links">
                            {/*<!--<li className="list-inline-item"><a href="#">Terms</a></li>-->
            <!--<li className="list-inline-item"><a href="#">Privacy</a></li>-->
            <li className="list-inline-item"><a href="#">Contact Us</a></li>*/}
                        </ul>
                    </div>
                </div>
                <a href="#top" className="btn btn-icon btn-inverse pos-fixed pos-b pos-r mr-3 mb-3 scroll-state-hidden hidden-md-down" title="Back to top" data-scroll="scroll-state"><i className="fa fa-chevron-up"></i></a>
            </footer>
        )
    }
}



// WEBPACK FOOTER //
// ./src/container/Footer.js